 

 
export default class ImageTools { 
    convertToImage = (blob, fileName) => {
        return new File([blob], fileName, { lastModified: new Date() });
    }
}